package com.eladfinish.bible.contest.screens.lexicographicalSort

import com.eladfinish.bible.contest.analytics.AnalyticsConstants.LexicographicalSort
import com.eladfinish.bible.contest.screens.browse.tableOfContents.model.OutputChapters

/**
 * What a table is, as the sort events report it: its [OutputChapters] and the book's number 1..39, as text.
 * The chapter says something only about a single-chapter table, so it is left out of every other one.
 */
internal fun lexicographicalSortParams(
    outputChapters: OutputChapters,
    bookNumber: Int,
    chapterNumber: Int? = null,
): Map<String, Any> = buildMap {
    put(LexicographicalSort.PARAM_OUTPUT, outputChapters.analyticsValue)
    put(LexicographicalSort.PARAM_BOOK, bookNumber.toString())
    if (chapterNumber != null && outputChapters == OutputChapters.SINGLE) {
        put(LexicographicalSort.PARAM_CHAPTER, chapterNumber.toString())
    }
}

private val OutputChapters.analyticsValue: String
    get() = when (this) {
        OutputChapters.SINGLE -> LexicographicalSort.OUTPUT_SINGLE
        OutputChapters.BY_MIKUD -> LexicographicalSort.OUTPUT_BY_MIKUD
        OutputChapters.ALL -> LexicographicalSort.OUTPUT_ALL
    }
